import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import BundleCard from '../../OldRydercup/pages/BundleCard';
import Cart from '../../OldRydercup/pages/Cart';
import '../styles/BundlePage.css';
import Products from'../../products.json';

const BundlePage = ({ cart, updateCart }) => {
  const navigate = useNavigate();
  const [bundles, setBundles] = useState([]);
  const [showCart, setShowCart] = useState(false);

  useEffect(() => {
    // Mock data - in a real app you'd fetch this
    const mockBundles = Products.bundles;
    /* const mockBundles = [
      {
        id: 1,
        name: "Starter Bundle",
        description: "Perfect for beginners with essential items",
        price: 99.99,
        image: "https://via.placeholder.com/300x200?text=Starter+Bundle",
        details: "Includes: Basic item A, Basic item B, and Starter guide"
      },
      {
        id: 2,
        name: "Premium Bundle",
        description: "Our most popular package with advanced features",
        price: 199.99,
        image: "https://via.placeholder.com/300x200?text=Premium+Bundle",
        details: "Includes: Premium item X, Premium item Y, and Pro guide"
      },
      {
        id: 3,
        name: "Deluxe Bundle",
        description: "The ultimate package with all premium features",
        price: 299.99,
        image: "https://via.placeholder.com/300x200?text=Deluxe+Bundle",
        details: "Includes: Deluxe item Z, Deluxe item W, and Master guide"
      }
    ]; */
    setBundles(mockBundles);
  }, []);

  const handleBundleSelect = (bundle) => {
    // Create a new cart object with the selected bundle
    const newCart = {
      ...cart,
      bundle: {
        id: bundle.id,
        name: bundle.name,
        price: bundle.price,
        image: bundle.image,
        details: bundle.details
      },
      // Reset item selections when changing bundles
      firstChoice: null,
      secondChoice: null,
      thirdChoice: null
    };
    
    updateCart(newCart);
    navigate(`/bundle/${bundle.id}`);
  };

  const handleContinue = () => {
    if (cart.bundle) {
      navigate('/items');
    }
  };

  return (
    <div className="bundle-page-container">
      <div className="bundle-selection-container">
        <h1>Select Your Bundle</h1>
        <p className="subtitle">Choose the bundle that best fits your needs</p>
        
        <div className="bundles-grid">
          {bundles.map(bundle => (
            <BundleCard
              key={bundle.id}
              bundle={bundle}
              isSelected={cart.bundle?.id === bundle.id}
              onSelect={() => handleBundleSelect(bundle)}
            />
          ))}
        </div>
        
        <div className="navigation-buttons">
          <button 
            className="back-button"
            onClick={() => navigate('/address')}
          >
            Back
          </button>
          <button
            className="continue-button"
            onClick={handleContinue}
            disabled={!cart.bundle}
          >
            Continue to Items
          </button>
          <button
            className="view-cart-button"
            onClick={() => setShowCart(!showCart)}
          >
            {showCart ? 'Hide Cart' : 'View Cart'}
          </button>
        </div>
      </div>
      
      {showCart && (
        <div className="cart-sidebar">
          <Cart 
            cart={cart} 
            bundles={bundles} 
            onClose={() => setShowCart(false)}
            editable={true}
          />
        </div>
      )}
    </div>
  );
};

export default BundlePage;